import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { memo, useEffect, useState } from "react";
import {
  routeConfigObjectLevelSelector,
  volumesSinceLastReadyTimeSelector,
} from "../../../reducers/matrixProfile/selectors";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import { View } from "../../View";
import { palette } from "../../../theme/palette";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  volumeContainer: {
    pointerEvents: "none",
    minWidth: "26px",
    height: "26px",
    lineHeight: "26px",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
    position: "relative",
    backgroundColor: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
  },
  markerContainer: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "2px",
  },
  container: {
    maxWidth: "86px",
    minWidth: "30px",
    minHeight: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
  },
  arrowContainer: {
    display: "flex",
    justifyContent: "center",
  },
  arrow: {
    width: "0",
    height: "0",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "10px solid white",
  },
  spacing: {
    padding: "2px",
  },
  icon: {
    height: "10px",
    width: "10px",
  },
});

export const VolumeMarker = memo(({ postcode }) => {
  const routeConfig = useSelector(routeConfigObjectLevelSelector);
  const volumes = useSelector(volumesSinceLastReadyTimeSelector);
  const [volume, setVolume] = useState(0);
  const styles = useStyles();

  useEffect(() => {
    if (!routeConfig) {
      return setVolume(0);
    }
    setVolume(
      !isNaN(volumes?.[postcode]?.stops) && volumes[postcode]?.stops !== null
        ? volumes[postcode]?.stops
        : routeConfig[postcode]?.totalStops
    );
  }, [postcode, routeConfig, volumes]);

  return volume ? (
    <View className={styles.markerContainer}>
      <View>
        <Grid container className={styles.container}>
          <Grid item container xs className={styles.spacing} direction={"row"}>
            <View className={styles.volumeContainer}>
              {volume}
              <LocationOnIcon className={styles.icon} />
            </View>
          </Grid>
        </Grid>
        <View className={styles.arrowContainer}>
          <View className={styles.arrow} />
        </View>
      </View>
    </View>
  ) : null;
});
